import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const special = new Restful(project, 'special')

special.getByTitle = data => {
  const url = project + 'special/title'
  return http.get(url, data).then(res => {
    return res
  })
}

special.submitManuscript = data => {
  const url = project + 'special/submit_manuscript'
  return http.get(url, data).then(res => {
    return res
  })
}

special.checkEmail = (email, data) => {
  const url = project + 'special/email/' + email
  return http.get(url, data).then(res => {
    return res
  })
}

special.geditorSearch = keyword => {
  const url = project + 'special/geditor/search'
  return http.get(url, { keyword }).then(res => {
    return res
  })
}

special.getArticle = (id, data) => {
  const url = project + 'special/' + id + '/article'
  return http.get(url, data).then(res => {
    return res
  })
}

special.getParticle = (id, data) => {
  const url = project + 'special/' + id + '/particle'
  return http.get(url, data).then(res => {
    return res
  })
}

special.queryParticle = (id, aid, data) => {
  const url = project + 'special/' + id + '/particle/' + aid
  return http.get(url, data).then(res => {
    return res
  })
}

special.addParticle = (id, data) => {
  const url = project + 'special/' + id + '/particle'
  return http.post(url, data).then(res => {
    return res
  })
}

special.updateParticle = (id, aid, data) => {
  const url = project + 'special/' + id + '/particle/' + aid
  return http.put(url, data).then(res => {
    return res
  })
}

special.articleExp = (id, data) => {
  const url = project + 'special/' + id + '/article/export'
  return http.octetget(url, data).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}

special.particleExp = (id, data) => {
  const url = project + 'special/' + id + '/particle/export'
  return http.octetget(url, data).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}

special.delParticle = (id, aid) => {
  const url = project + 'special/' + id + '/particle/' + aid
  return http.del(url).then(res => {
    return res
  })
}

const specialApply = new Restful(project, 'special/apply')

specialApply.accepted = (id, data) => {
  const url = project + 'special/apply/accepted/' + id
  return http.put(url, data).then(res => {
    return res
  })
}
specialApply.refused = (id, data) => {
  const url = project + 'special/apply/refused/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

export { special, specialApply }
export default special
